import React, { useMemo } from "react";
import { getStorageValues } from "../../../shared/CommonFunctions";
import ReportViewer from "./components/ReportViewer";
import { generateStandardReportPdf } from "./utils/reportPdfGenerators";
import moment from "moment";

export default function FollowupDueReport() {
  const formatDateTime = (value) => {
    if (!value) return "-";
    const m = moment(value, [moment.ISO_8601, "YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD", "DD/MM/YYYY", "DD/MM/YYYY HH:mm:ss"], true);
    return m.isValid() ? m.format("DD/MM/YYYY hh:mm A") : String(value);
  };

  const columns = useMemo(
    () => [
      { name: "Type", selector: (r) => r.SourceType || "-" },
      { name: "Key", selector: (r) => r.FollowupKey || "-" },
      { name: "Customer", selector: (r) => r.CustomerName || "-" },
      { name: "Follow-up Date", selector: (r) => formatDateTime(r.FollowupDate) },
      { name: "Remarks", selector: (r) => r.FollowupRemarks || "-" },
    ],
    []
  );

  return (
    <ReportViewer
      reportKey="followupDue"
      title="Follow-up Due"
      columns={columns}
      fetchConfig={{
        url: "/dashboard/app2followupreminders",
        paramsBuilder: () => ({ UserId: getStorageValues("userId") }),
        transform: (data) => {
          // controller returns listRows (array) but some callers normalize; handle both
          if (Array.isArray(data)) return data;
          if (Array.isArray(data?.[0])) return data[0];
          return [];
        },
      }}
      buildKpis={(rows) => [{ label: "Total Due", value: rows?.length ?? 0 }]}
      pdfGenerator={generateStandardReportPdf}
    />
  );
}

